import { AxiosPromise } from 'axios';
import { URLS } from '@/services/Constants';
import { commonAxios as axios } from '@/services/Authentication';

export default {
    // GET

    /**
     * Get connected user object
     *
     * @returns {AxiosPromise<any>}
     */
    getActiveUser(): AxiosPromise<any> {
        return axios().request({
            url: URLS().urlActiveUser,
            method: 'get'
        });
    },

    /**
     * Return all users
     *
     * @returns {AxiosPromise<any>}
     */
    getAllUsers(): AxiosPromise<any> {
        return axios().request({
            url: URLS().urlUsers,
            method: 'get'
        });
    },

    /**
     * Return User by Id
     *
     * @param {string} userId
     * @returns {AxiosPromise<any>}
     */
    getUserById(userId: string): AxiosPromise<any> {
        return axios().request({
            url: URLS().urlUsers + '/' + userId,
            method: 'get'
        });
    },
    /**
     * Return the PhoneNumber with the given {phoneNumberId}
     *
     * @param {string} phonenumberId
     * @returns {AxiosPromise<any>}
     */
    getPhonenumber(phonenumberId: string): AxiosPromise<any> {
        return axios().request({
            url: URLS().urlPhonenumbers + '/' + phonenumberId,
            method: 'get'
        });
    },


    /**
     * Return a list of assigned phone numbers for the User with the given {userId}
     *
     * @param {string} userId
     * @returns {AxiosPromise<any>}
     */
    getPhonenumbersForUser(userId: string): AxiosPromise<any> {
        return axios().request({
            url: URLS().urlUsers + '/' + userId + URLS().urlEndingPhoneConfig,
            method: 'get'
        });
    },

    // POST

    /**
     * Create new user
     *
     * @param {*} data
     * @returns {AxiosPromise<any>}
     */
    createUser(data: any): AxiosPromise<any> {
        return axios().request({
            url: URLS().urlUsers,
            method: 'post',
            data
        });
    },

    /**
     * Assignes phone numbers to the User with the given {userId}
     *
     * @param {string} userId
     * @param {any[]} phonenumbers
     * @returns {AxiosPromise<any>}
     */
    assignPhonenumbersForUser(
        userId: string,
        phonenumbers: any[]
    ): AxiosPromise<any> {
        return axios().request({
            url: URLS().urlUsers + '/' + userId + URLS().urlEndingPhoneConfig,
            method: 'post',
            data: phonenumbers
        });
    },

    // PUT

    /**
     * Update user according provided data and user Id
     *
     * @param {string} userId
     * @param {*} data
     * @returns {AxiosPromise<any>}
     */
    updateUser(userId: string, data: any): AxiosPromise<any> {
        return axios().request({
            url: URLS().urlUsers + '/' + userId,
            method: 'put',
            data
        });
    },

    /**
     * Revoke user login permissions to old frontend according provided data and user Id
     *
     * @param {string} userId
     * @param {*} data
     * @returns {AxiosPromise<any>}
     */
    revokeUserLogin(userId: string, data: any): AxiosPromise<any> {
        return axios().request({
            url: URLS().urlPermissions + '/' + userId,
            method: 'put',
            data
        });
    },

    /**
     * Assignes phone numbers to the User with the given {userId}
     *
     * @param {string} userId
     * @param {any[]} phonenumbers
     * @returns {AxiosPromise<any>}
     */
    updatePhonenumbersForUser(
        userId: string,
        phonenumbers: any[]
    ): AxiosPromise<any> {
        return axios().request({
            url: URLS().urlUsers + '/' + userId + URLS().urlEndingPhoneConfig,
            method: 'put',
            data: phonenumbers
        });
    },

    // DELETE

    /**
     * Remove use by Id
     *
     * @param {string} userId
     * @returns {AxiosPromise<any>}
     */
    deleteUser(userId: string): AxiosPromise<any> {
        return axios().request({
            url: URLS().urlUsers + '/' + userId,
            method: 'delete'
        });
    },

    /**
     * Deletes the PhoneNumberAssignment from the User with the given {userId}
     *
     * @param {string} userId
     * @param {string} phonenumberId
     * @returns {AxiosPromise<any>}
     */
    deleteUsersPhonenumber(
        userId: string,
        phonenumberId: string
    ): AxiosPromise<any> {
        if (phonenumberId === null) {
            return new Promise((resolve) => resolve());
        }
        return axios().request({
            url:
                URLS().urlUsers +
                '/' +
                userId +
                URLS().urlEndingPhoneConfig +
                '/' +
                phonenumberId,
            method: 'delete'
        });
    },

    // POSTPROCESSING

    findUserIdByLogin(users: any[], login: string): any {
        return users.find(user => user.login === login);
    }
};
